(function() {
  function repositionVideos() {
    var pvSection = document.querySelector('.pv-section');
    if (!pvSection) return;

    var paymentIcons = document.querySelector('.payment-icons');

    if (paymentIcons) {
      var target = paymentIcons;
      while (target && target.parentElement) {
        if (target.parentElement.classList.contains('group-block-content')) {
          target.parentElement.insertBefore(pvSection, target.nextSibling);
          return;
        }
        target = target.parentElement;
      }
    }

    /* Fallback: after product-form-component */
    var formComponent = document.querySelector('product-form-component');
    if (!formComponent) return;
    var target2 = formComponent;
    while (target2 && target2.parentElement) {
      if (target2.parentElement.classList.contains('group-block-content')) {
        target2.parentElement.insertBefore(pvSection, target2.nextSibling);
        return;
      }
      target2 = target2.parentElement;
    }
  }

  function run() {
    setTimeout(repositionVideos, 300);
    setTimeout(repositionVideos, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();